import React from 'react';

interface Props {
  status: string;
  size?: 'sm' | 'md';
}

const STATUS_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  unconfirmed: { label: 'Non vérifié', color: 'var(--red)', bg: 'var(--red-dim)' },
  probable: { label: 'Probable', color: 'var(--orange)', bg: 'var(--orange-dim)' },
  confirmed: { label: 'Confirmé', color: 'var(--green)', bg: 'var(--green-dim)' },
};

export function StatusBadge({ status, size = 'md' }: Props) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.unconfirmed;
  const fontSize = size === 'sm' ? '10px' : '11px';
  const padding = size === 'sm' ? '2px 6px' : '3px 10px';

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding,
      borderRadius: '20px',
      fontSize,
      fontWeight: 600,
      color: config.color,
      background: config.bg,
    }}>
      {status === 'confirmed' ? '●' : status === 'probable' ? '●' : '●'} {config.label}
    </span>
  );
}
